module.exports = {
    useRegistrationPage: process.env.USE_REGISTRATION_PAGE === 'true',
    useLoginPage: process.env.USE_LOGIN_PAGE === 'true',
    allowQuickSignup: process.env.ALLOW_QUICK_SIGNUP === 'true',
};